import {Box} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';

export interface Props {
  label: string;
  active: boolean;
  onClick: () => void;
}

export const WorkforceProfileAlignmentFilterButton = ({label, active, onClick}: Props) => (
  <Box
    component='button'
    type='button'
    onClick={onClick}
    sx={{
      fontSize: 12,
      px: '12px',
      py: '4px',
      borderRadius: '20px',
      border: `0.5px solid ${orangeColors[3]}`,
      bgcolor: active ? orangeColors[5] : 'transparent',
      color: active ? 'text.primary' : 'text.secondary',
      cursor: 'pointer',
      fontFamily: 'inherit',
      transition: 'all 0.15s ease',
      '&:hover': {
        bgcolor: orangeColors[5],
        color: 'text.primary',
      },
    }}
  >
    {label}
  </Box>
);
